import { Box, Divider, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Navigate } from "react-router-dom";
import Footer from "components/layout/Footer";
import PageTitle from "components/layout/PageTitle";
import { useUserData } from "features/User";
import GroupPreferencesTable from "features/Group/components/GroupPreferencesTable";
import { fillParent, scrollingBox, footerFlex } from "utils/base-styles";

export default function GroupPreferences() {
  const { groupId, groupRole } = useUserData();

  if (groupId == null || groupRole !== "OrganizationAdmin") {
    return <Navigate to="/profile" replace />;
  }

  return (
    <Box sx={{ ...fillParent, ...scrollingBox, ...footerFlex }}>
      <Helmet>
        <title>Sooth - Group Management - Group Preferences</title>
      </Helmet>
      <Stack direction="column" pb="50px">
        <PageTitle>Group Preferences</PageTitle>
        <Typography>
          Welcome to the group preferences page. Here, you can manage settings
          to tailor the Sooth experience for your group. As your group's needs
          change, come back here to update preferences that support your members'
          research activities.
        </Typography>
        <Divider sx={{ my: 4 }} />
        <GroupPreferencesTable />
      </Stack>
      <Footer sx={{ px: 0 }} />
    </Box>
  );
}
